import { DateTime } from "luxon";
import axios from "axios";
export function getDateRange(data) {
  let date = DateTime.fromISO(data.from);
  const end = DateTime.fromISO(data.to);
  const range = [];
  while (date <= end) {
    range.push(date.toJSON());
    date = date.plus({ days: 1 });
  }
  return range;
}
export async function getHolidays(data, errorFunc) {
  const from = DateTime.fromJSDate(new Date(data.from)).toFormat("yyyy-LL-dd");
  const to = DateTime.fromJSDate(new Date(data.to)).toFormat("yyyy-LL-dd");
  const url =
    `https://openholidaysapi.org/${data.type}?countryIsoCode=DE&languageIsoCode=DE` +
    `&validFrom=${from}&validTo=${to}&subdivisionCode=DE-${data.subdivisionCode}`;
  let result = [];
  try {
    result = (await axios.get(url))?.data || [];
  } catch (e) {
    console.error(e);
    if (errorFunc) errorFunc(e);
  }
  return result;
}
export function getHolidayQueryObject(year, state, type) {
  return {
    from: new Date(year + "-01-01"),
    to: new Date(year + "-12-31"),
    subdivisionCode: state,
    type
  };
}
export const states = [
  {
    text: "Bayern",
    value: "BY"
  },
  {
    text: "Baden-Wuerttemberg",
    value: "BW"
  },
  {
    text: "Niedersachsen",
    value: "NI"
  },
  {
    text: "Berlin",
    value: "BE"
  },
  {
    text: "Brandenburg",
    value: "BB"
  },
  {
    text: "Bremen",
    value: "HB"
  },
  {
    text: "Hamburg",
    value: "HH"
  },
  {
    text: "Hessen",
    value: "HE"
  },
  {
    text: "Mecklenburg-Vorpommern",
    value: "MV"
  },
  {
    text: "Nordrhein-Westfalen",
    value: "NW"
  },
  {
    text: "Rheinland-Pfalz",
    value: "RP"
  },
  {
    text: "Saarland",
    value: "SL"
  },
  {
    text: "Sachsen",
    value: "SN"
  },
  {
    text: "Sachsen-Anhalt",
    value: "ST"
  },
  {
    text: "Schleswig-Holstein",
    value: "SH"
  },
  {
    text: "Thueringen",
    value: "TH"
  }
];
